import { spacing } from "globalStyles";
import React, { ChangeEvent, InputHTMLAttributes } from "react";
import styled from "styled-components";
import InputContainer from "./components/Container";
import InputHelperText from "./components/HelperText";
import { InputColor, InputProps } from "./interfaces";

const textVariant = "body6";
const borderWidth = 1;

interface Props extends InputProps, InputHTMLAttributes<HTMLInputElement> {
  color?: InputColor;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  id?: string;
  name: string;
  value?: string | number;
  placeholder?: string;
}

const Input: React.FC<Props> = ({
  id,
  name,
  value,
  placeholder,
  onChange,
  color = "primary",
  hasError = false,
  errorMessage = "",
  helperText = "",
  className,
  ...other
}) => {
  return (
    <InputContainer className={className}>
      <StyledInput
        id={id || name}
        name={name}
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        color={color}
        hasError={hasError}
        {...other}
      />
      <InputHelperText
        hasError={hasError}
        errorMessage={errorMessage}
        helperText={helperText}
        color={color}
      />
    </InputContainer>
  );
};

export default Input;

const StyledInput = styled.input<{ color: InputColor; hasError: boolean }>`
  padding: ${spacing.small - borderWidth}px ${spacing.medium}px;
  border-radius: 7px;
  border-style: solid;
  border-width: ${borderWidth}px;
  border-style: solid;
  outline: 0;

  ${({ theme, color, hasError }) => `
    border-color:  ${hasError ? theme.colors.danger : theme.colors.input[color].border};
    font-family: ${theme.typography.body[textVariant].fontFamily};
    font-weight: ${theme.typography.body[textVariant].fontWeight};
    font-size: ${theme.typography.body[textVariant].fontSize}px;
    color: ${theme.colors.input[color].content};
  `}

  ::placeholder {
    color: ${({ theme, color }) => theme.colors.input[color].placeholder};
  }

  :focus {
    border-width: 2px;
  }
`;
